import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Index from '../../../Index';
import PagesIndex from '../../../PagesIndex';

const Layout = () => {
  const [currentTab,setCurrentTab]=useState("no tab")
  return (
    <>
      <PagesIndex.Header currentTab={currentTab} setCurrentTab={setCurrentTab}/>
      <Outlet  context={[currentTab,setCurrentTab]}/>
      <PagesIndex.Footer />
      <Index.Box className="top-scroll-box" id="top-scroll-box">
        <Index.Button className="top-scroll-btn" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}><img src={PagesIndex.Svg.topArrow} className="top-scroll-icon" /></Index.Button>
      </Index.Box>
    </>
  )
}

export default Layout;